import React from 'react';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import FooterCopyright from "../components/FooterCopyright";
const Contact = () => {
  return (
    <>
      <div className="pages contact">
        <h1 className="title">Contact Us</h1>
      </div>
      <div className="map">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d475.7130384334104!2d78.2964347!3d17.4738612!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93004d110f1b%3A0x3509d79d506a3bff!2sLittle%20Sanctum%20Montessori!5e0!3m2!1sen!2sin!4v1744376831219!5m2!1sen!2sin" 
          style={{ border: 0 }}
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <ContactUs />
      <Footer />
      <FooterCopyright />
    </>
  )
}

export default Contact
